import React, { useEffect } from 'react';
import { Button, Grid } from '@mui/material';
import { FaClipboardList } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { Link, useNavigate } from 'react-router-dom';
import SelectOption from '../../components/mui/SelectOption';
export default function UserDetail({role}) {
  const navigate =useNavigate()
  useEffect(()=>{
    document.title = "RollingAdz: User Details" || "Default Title";
  },[])
  return (
    <div>

      {/*---------------- Activity::a Section ----------------*/}
      <section className="activity-sec mt-3">
        <div className="container">
        <Grid container spacing={2}>
  <Grid item xs={12} sm={6}   lg={4} >
  
    <div className="mt-3" onClick={()=>navigate("/admin/campaigns")}>
              <div className="bg-white rounded-3 shadow p-3 d-flex align-items-center">
                <div className='text-primary p-3 rounded-3'>
                  <FaClipboardList size={35}/>
                </div>
                <Link to="/positions" style={{textDecoration:"none"}}>
                <div className="ps-">
                  <h5 className="fs-6 text-secondary white_space mb-0 ">Campaigns</h5>
                  <p className="fs-4 text-dark mont-font lh-1 mt-2 mb-0">65</p>
                </div>
                </Link>
              </div>
            </div>
 
  </Grid>
  <Grid item xs={12} sm={6}  lg={4}>

    <div className="mt-3" onClick={()=>navigate("/admin/requests")}>
              <div className="bg-white rounded-3 shadow p-3 d-flex align-items-center">
                <div className='text-danger new-off p-3  rounded-3'>
                <FaClipboardList size={35}/>
                </div>
             
                <div className="">
                  <h5 className="fs-6 text-secondary white_space mb-0 ">Requests</h5>
                
                  <p className="fs-4 text-dark mont-font lh-1 mt-2 mb-0">10</p>
                </div>
          
              </div>
            </div>

  </Grid>
  <Grid item xs={12} sm={6}  lg={4}>

    <div className="mt-3" onClick={()=>navigate("/admin/payments")}>
              <div className="bg-white rounded-3 shadow p-3 d-flex align-items-center">
                <div className='text-danger new-off p-3  rounded-3'>
                <FaClipboardList size={35}/>
                </div>
    
                <div className="">
                  {/* <h5 className="fs-6 text-secondary white_space mb-0 ">Currently Working Matches</h5> */}
                  <h5 className="fs-6 text-secondary white_space mb-0 text-wrap ">Invoices</h5>
                  <p className="fs-4 text-dark mont-font lh-1 mt-2 mb-0">10</p>
                </div>
              
              </div>
            </div>
 
  </Grid>
  
</Grid>
  
        </div>
      </section>

      <section>
      <div class="container">
    <div class="row align-items-start mt-5 gap-2 gx-3">
      <div class="col-md-5">
        <div class="card  text-dark">
          <div class="card-body ">
            <div className='d-flex justify-content-end'>
              <FiEdit style={{cursor:"pointer"}} onClick={()=>navigate("/advertiser-account")} size={30}/>
            </div>
            <h2 class="card-title">User Information</h2>
            <p class="card-text"><strong>Name:</strong> John Doe</p>
            <p class="card-text"><strong>Email:</strong> john.doe@example.com</p>
            <p class="card-text"><strong>Phone:</strong> +1 (555) 123-4567</p>
            <p class="card-text"><strong>Address:</strong> 1234 Main St, Anytown, USA</p>
          </div>
        </div>
      </div>
      <div className='col-md-5'>
<SelectOption
label={"Role"}
data={[
  {id:1,role:"Installer"},
  {id:2,role:"Photographer"},
  {id:3,role:"Vehicle Owner"},
  {id:4,role:"Advertiser"},
  {id:5,role:"DesignerAccount"},
  ]}
  value={1}
  
/>
        </div>
    </div>
    </div>
      </section>

    </div>
  )
}
